var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMilkywireSymbol(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 668 542",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.35 0c-85.51 0-155.79 65.15-163.87 148.49h-10.95C320.44 65.15 250.16 0 164.65 0 73.72 0 0 73.67 0 164.55v268.81C0 493.36 48.67 542 108.72 542c54.53 0 99.69-40.13 107.51-92.45h10.05C234.1 501.87 279.25 542 333.79 542c54.54 0 99.69-40.13 107.51-92.45h10.48c7.82 52.32 52.97 92.45 107.5 92.45C619.33 542 668 493.36 668 433.35v-268.8C668 73.67 594.28 0 503.35 0z",
    fill: "#000"
  })));
}

export default SvgMilkywireSymbol;